import React from 'react';
import { connect } from 'react-redux';
import { Modal, Form,Select,message } from 'antd';
import * as actionTypes from '../../redux/actions/3DCollection/actionTypes';
import { updateThreeD } from '../../redux/actions/3DCollection/updateThreeD';

class UpdateThreeDModal extends React.Component {
    constructor(props) {
        super(props);
        this.form = React.createRef();
    }
    layout = {
        labelCol: {
            span: 8,
        },
        wrapperCol: {
            span: 12,
        },
    };
    tailLayout = {
        wrapperCol: {
            offset: 12,
            span: 16,
        },
    };
    onFinish = async (values) => {
        await this.props.onUpdate(
            this.props.number?.id,
            values.status
            , this.props.token);
        this.form.current.resetFields();
        this.props.onClose();
        if (this.props.error) {
            message.error(this.props.error);
        }
        if (this.props.message) {
            message.success(this.props.message);
        }
    }
    onFinishFailed = (errors) => {
        console.log(errors)
    }
    handleCancel = () => {
        this.props.onClose();
    }
    render() {
        const {Option}=Select;
        return (
            <Modal
                title="Update Status"
                key={this.props.number?.id}
                centered
                visible={this.props.visible}
                okButtonProps={{ form: 'update-3dstatus-form', key: 'submit', htmlType: 'submit' }}
                confirmLoading={this.props.loading}
                onCancel={this.handleCancel}
                okText="Save"
                loading={this.props.loading}
            >
                <Form
                    ref={this.form}
                    style={{ margin: 25 }}
                    id="update-3dstatus-form"
                    {...this.layout}
                    name="basic"
                    initialValues={{
                        status: this.props.number?.status
                    }}
                    onFinish={this.onFinish}
                    onFinishFailed={this.onFinishFailed}
                >
                    <Form.Item
                        name="status"
                        label="Status"
                        rules={[
                            {
                                required: true,
                                message: 'Require!',
                            }
                        ]}
                    >
                        <Select style={{width:200}}>
                            <Option value={1}>Normal</Option>
                            <Option value={2}>Special</Option>
                            <Option value={3}>Closed</Option>
                        </Select>
                    </Form.Item>
                </Form>
            </Modal>
        );
    }
}

const mapStateToProps = state => ({
    visible: state.threeDCollection.updateVisible,
    loading: state.threeDCollection.loading,
    token: state.auth.token,
    error: state.threeDCollection.error,
    message: state.threeDCollection.message,
    number: state.threeDCollection.toUpdate
})

const mapDispatchToProps = dispatch => ({
    onUpdate: (id, status, token) => dispatch(updateThreeD(id, status, token)),
    onClose: () => dispatch({
        type:actionTypes.TOGGLE_3D_STATUS_UPDATE
    }),
})

export default connect(mapStateToProps, mapDispatchToProps)(UpdateThreeDModal);